import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import ApplicationStore from '../stores/ApplicationStore';
import { LeadActivityAttachment } from '../types/Lead';
import { client } from '../utils/axios-client';

export const ServerStateKey = ['lead-activity-attachment-list'];
export const apiUri = '/api/leads/activity-attachments';

export const useGetItems = (leadId: string | undefined, activityTypeId: string | undefined) => useQuery<LeadActivityAttachment[]>({
    queryKey: ServerStateKey,
    queryFn: () => client.get(apiUri, { params: { leadId, activityTypeId } }).then((res) => res.data)
})

export const useAddItem = () => {
    const cache = useQueryClient();

    return useMutation(
        (updatedItem: FormData) => client.post(apiUri, updatedItem).then((res) => res.data),
        {
            onSuccess: () => {
                cache.invalidateQueries(ServerStateKey);

                ApplicationStore.update(s => {
                    s.snackbarMessage = "Attachment saved successfully";
                    s.snackbarOpen = true;
                });
            }
        });
}

export const useDeleteItem = () => {
    const cache = useQueryClient();

    return useMutation(
        (attachmentId: string) => client.delete(apiUri, { params: { attachmentId } }).then((res) => res.data),
        {
            onSuccess: () => {
                cache.invalidateQueries(ServerStateKey);

                ApplicationStore.update(s => {
                    s.snackbarMessage = "Attachment deleted successfully";
                    s.snackbarOpen = true;
                });
            }
        });
}